/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
export function getItem(key: string) {
    try {
        const val = localStorage.getItem(key);
        if (val) {
            const item = JSON.parse(val);
            return item;
        }
    } catch (e) {
        return console.error(e);
    }
    return null;
}

export function setItem(key: string, valObject: any) {
    if (valObject) {
        try {
            const val = JSON.stringify(valObject);
            localStorage.setItem(key, val);
        } catch (e) {
            return console.error(e);
        }
    }
}

export function removeItem(aKey: string[]) {
    if (aKey.length > 0) {
        aKey.forEach((key: string) => {
            if (key) {
                try {
                    localStorage.removeItem(key);
                } catch (e) {
                    return console.error(e);
                }
            }
        });
    }
}
